import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getChargeElementKey } from '../../../services/get-charge-element-key';
import { getJiraApplicationKey } from '../../../services/get-jira-application-key';
import { getJiraProjectTypeKey } from '../../../services/get-jira-project-type-key';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, type EntryPointParams } from './standardAddPaymentModal.entrypoint';

export function StandardAddPaymentModal(): React.JSX.Element {
	const { product, cloudId } = useEditionAwareness();

	const projectType = getJiraProjectTypeKey(product);
	const jiraApplicationKey = getJiraApplicationKey(product);

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			hamsProductKey: getHamsKey(product),
			chargeElement: getChargeElementKey(product),
			// Fallback to any valid value since this means that we're not using jira
			jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
			// Fallback to any valid value since this means that we're not using jira
			projectType: projectType ?? 'SOFTWARE',
			isJira:
				product === 'jira' ||
				product === 'jira-product-discovery' ||
				product === 'jira-service-management',
			isConfluence: product === 'confluence',
		}),
		[cloudId, product, projectType, jiraApplicationKey],
	);

	const modalProps = useMemo(() => {
		if (product === 'confluence') {
			return { width: 1000, height: 600 };
		}

		return { width: 968, height: 576 };
	}, [product]);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
